<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Home' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div class="d2c-class-container" style="padding-top: 77px;">
              <!-- Nav tabs -->
              <h2 class="listing-page-title">Renewals</h2>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>

      <div class="container multistep-box" style="margin: 50px auto 20px; text-align: center;">
        <div class="row ib-default-flex my-3">
          <ul class="nav nav-tabs jbl-nav-tabs" id="myTab" role="tablist" style="width:290px; text-align:center;">
            <li class="nav-item">
              <a class="nav-link active" id="expiring-soon-tab" data-toggle="tab" href="#expiring-soon" role="tab" aria-controls="expiring-soon" aria-selected="true">
                <div>Expiring Soon</div>
              </a>
            </li>
            <li class="nav-item" style="flex:1;">
              <a style="width:100%;" class="nav-link" id="expired-tab" data-toggle="tab" href="#expired" role="tab" aria-controls="expired" aria-selected="false">
                <div>Expired</div>
              </a>
            </li>
          </ul>
        </div>

        <div class="row tab-content" id="myTabContent">
          <div class="col-md-12 tab-pane fade active show" id="expiring-soon" role="tabpanel" aria-labelledby="expiring-soon-tab">
            <div class="col-md-12 d-none d-md-block">
              <table class="claim-listing">
                <tbody>
                  <tr v-for="(expiringPolicy, index) in expiringPolicies" :key="'expiringPolicy' + index" @click="viewExpiringPolicy(expiringPolicy.id)">
                    <td class="jbl-responsive-td data-img">
                      <div class="in-listing-img">
                        <img class="img-fluid" :src="expiringPolicy.plan_image" v-if="expiringPolicy.plan_image != ''" />
                        <img class="img-fluid" :src="expiringPolicy.product_image" v-if="expiringPolicy.plan_image == ''" />
                        <div class="position-relative-box">
                        <img alt="icon" class="img-fluid small-icon" style="right:5px;" :src="expiringPolicy.company_logo_path" />
                        </div>
                      </div>
                    </td>
                    <td class="jbl-table-heading jbl-responsive-td">
                      <div class="expired-title">{{ expiringPolicy.subclass_name }}
                        <small>{{ expiringPolicy.product_name }}</small>
                        <small v-if="expiringPolicy.plan_name != ''" class="ib-card-plan">{{ expiringPolicy.plan_name }}</small>
                      </div>
                    </td>
                    <td class="jbl-responsive-td" v-if="expiringPolicy.policy_no != null">
                      <div class="jbl-flex-td">
                        <div class="jbl-date-td jbl-date-heading">Policy No</div>
                        <div class="jbl-date-td">{{ expiringPolicy.policy_no}}</div>
                      </div>
                    </td>
                    <td class="jbl-responsive-td" v-else>
                      <div class="jbl-flex-td">
                        <div class="jbl-date-td jbl-date-heading">Order No</div>
                        <div class="jbl-date-td">{{ expiringPolicy.tcn_no}}</div>
                      </div>
                    </td>
                    <td class="jbl-responsive-td">
                      <div class="jbl-flex-td">
                        <div class="jbl-date-td jbl-date-heading">Package Price</div>
                        <div class="jbl-date-td ib-td-currency">PKR <span>{{ priceFormatter(expiringPolicy.paid_amount) }}</span></div>
                      </div>
                    </td>
                    <td class="jbl-responsive-td">
                      <div class="jbl-flex-td">
                        <div class="jbl-date-td jbl-date-heading">Order Date</div>
                        <div class="jbl-date-td"><span>{{ formatDate(expiringPolicy.created_at) }}</span></div>
                      </div>
                    </td>
                    <td class="jbl-responsive-td">
                      <div class="jbl-flex-td">
                        <div class="jbl-date-td jbl-date-heading">Expiry Date</div>
                        <div class="jbl-date-td"><span>{{ formatDate(expiringPolicy.expires_at) }}</span></div>
                      </div>
                    </td>
                    <td class="jbl-responsive-td">
                      <div class="jbl-flex-td">
                        <div class="jbl-date-td jbl-date-heading expired-days-label">Expiring In</div>
                        <div class="jbl-date-td expired-days">{{ calculateExpiry(expiringPolicy.expires_at) }} <small>Days</small></div>
                      </div>
                    </td>
                    <td class="jbl-responsive-td in-w-60">
                      <!-- <i class="fa fa-chevron-right"></i> -->
                      <!-- <img class="img-fluid in-w-10" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon"> -->
                      <span style="float:right" ><i class="arrow_risk right1 feedback_arrow"></i></span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h2 style="color: rgba(0, 0, 0, 0.3) !important " v-if="expiringPolicies.length === 0">No Expiring Policy Found</h2>
            </div>

          <!-- mobile view -->
          <div class="col-md-12 d-md-none">
            <div class="d-flex in-sm-listing ib-cursor-pointer" v-for="(expiringPolicy, index) in expiringPolicies" :key="'expiringPolicy' + index" @click="viewExpiringPolicy(expiringPolicy.id)">
              <div class="in-sm-firstdiv">
                <div class="in-listing-img in-sm-height">
                  <img class="img-fluid" :src="expiringPolicy.plan_image" v-if="expiringPolicy.plan_image != ''" />
                  <img class="img-fluid" :src="expiringPolicy.product_image" v-if="expiringPolicy.plan_image == ''" />
                  <div class="position-relative-box">
                  <img alt="icon" class="img-fluid small-icon" :src="expiringPolicy.company_logo_path" />
                  </div>
                </div>
              </div>
               <div class="in-sm-flex1">
                <div class="d-flex in-sm-date">
                  <div>Order Date:&nbsp;</div>
                  <div>{{ formatDate(expiringPolicy.created_at) }}</div>
                </div>
                 <div class="in-sm-title">{{ expiringPolicy.subclass_name }}
                  <small>{{ expiringPolicy.product_name }}</small>
                  <!-- <small class="ib-card-plan" v-if="expiringPolicy.plan_name != ''">{{ expiringPolicy.plan_name }}</small> -->
                </div>
                <!-- <div class="in-sm-title" v-else>{{ document.subclass_name }}
                  <small class="ib-card-plan">{{ document.product_name }}</small>
                </div> -->
                <div>
                  <div class="d-flex">
                    <div class="in-sm-property">Policy No.</div>
                    <div class="in-sm-value">{{ expiringPolicy.policy_no}}</div>
                  </div>
                </div>
                <div>
                  <div class="d-flex">
                    <div class="in-sm-property">Expiring In: </div>
                    <div class="in-sm-value">{{ calculateExpiry(expiringPolicy.expires_at) }} <small>Days</small></div>
                  </div>
                </div>
                <div class="">
                  <div class="d-flex">
                    <div class="in-sm-value ib-td-currency">PKR <span>{{ priceFormatter(expiringPolicy.paid_amount) }}</span></div>
                  </div>
                </div>
                  <!-- <div class="in-sm-status ib-status" :class=" document.status +'-status'">{{ calculateExpiry(expiringPolicy.expires_at) }}</div> -->
              </div>
            </div>
            <h5 style="color: rgba(0, 0, 0, 0.3) !important " v-if="expiringPolicies.length === 0">No Expiring Policy Found</h5>
          </div>
          <!-- mobile view -->
          </div>
          <div class="col-md-12 tab-pane fade" id="expired" role="tabpanel" aria-labelledby="expired-tab">
            <div class="col-md-12 d-none d-md-block">
              <table class="claim-listing">
                <tbody>
                  <tr v-for="(expiredPolicy, index) in expiredPolicies" :key="'expiredPolicy' + index">
                    <td class="jbl-responsive-td data-img" @click="viewPolicy(expiredPolicy)">
                      <div class="in-listing-img">
                        <img class="img-fluid" :src="expiredPolicy.plan_image" v-if="expiredPolicy.plan_image != ''" />
                        <img class="img-fluid" :src="expiredPolicy.product_image" v-if="expiredPolicy.plan_image == ''" />
                        <div class="position-relative-box">
                        <img alt="icon" class="img-fluid small-icon" :src="expiredPolicy.company_logo_path" />
                        </div>
                      </div>

                    </td>
                    <td class="jbl-table-heading jbl-responsive-td" @click="viewPolicy(expiredPolicy)">
                      <div class="expired-title">{{ expiredPolicy.subclass_name }}
                        <small>{{ expiredPolicy.product_name }}</small>
                        <small v-if="expiredPolicy.plan_name != ''" class="ib-card-plan">{{ expiredPolicy.plan_name }}</small>
                      </div>
                    </td>
                    <td class="jbl-responsive-td" v-if="expiredPolicy.policy_no != null" @click="viewPolicy(expiredPolicy)">
                      <div class="jbl-flex-td">
                        <div class="jbl-date-td jbl-date-heading">Policy No</div>
                        <div class="jbl-date-td">{{ expiredPolicy.policy_no}}</div>
                      </div>
                    </td>
                    <td class="jbl-responsive-td" v-else @click="viewPolicy(expiredPolicy)" >
                      <div class="jbl-flex-td">
                        <div class="jbl-date-td jbl-date-heading">Order No</div>
                        <div class="jbl-date-td">{{ expiredPolicy.tcn_no}}</div>
                      </div>
                    </td>
                    <td class="jbl-responsive-td" @click="viewPolicy(expiredPolicy)">
                      <div class="jbl-flex-td">
                        <div class="jbl-date-td jbl-date-heading">Package Price</div>
                        <div class="jbl-date-td ib-td-currency">PKR <span>{{ priceFormatter(expiredPolicy.paid_amount) }}</span></div>
                      </div>
                    </td>
                    <td class="jbl-responsive-td" @click="viewPolicy(expiredPolicy)">
                      <div class="jbl-flex-td">
                        <div class="jbl-date-td jbl-date-heading">Order Date</div>
                        <div class="jbl-date-td"><span>{{ formatDate(expiredPolicy.created_at) }}</span></div>
                      </div>
                    </td>
                    <td class="jbl-responsive-td" @click="viewPolicy(expiredPolicy)">
                      <div class="jbl-flex-td">
                        <div class="jbl-date-td jbl-date-heading">Expiry Date</div>
                        <div class="jbl-date-td"><span>{{ formatDate(expiredPolicy.expires_at) }}</span></div>
                      </div>
                    </td>
                    <!-- <td class="jbl-responsive-td" v-if="expiredPolicy.can_renew_policy" @click="renewPolicy(expiredPolicy)">
                      <div class="jbl-flex-td">
                        <div class="jbl-date-td jbl-date-heading">Renew Now!</div>
                      </div>
                    </td> -->
                    <!-- <td class="jbl-responsive-td" @click="viewPolicy(expiredPolicy)">
                      <router-link :to="{ name: 'PolicyView', params: { source: 'self', id: expiredPolicy.id } }" class="nex-Page-Link">
                        <i class="fa fa-chevron-right"></i>
                      </router-link>
                    </td> -->

                    <td class="jbl-responsive-td in-w-60" :class="expiredPolicy.can_renew_policy ? 'in-renew-flex' : ''">
                       <div class="in-flex-data ib-btn-primary" v-if="expiredPolicy.can_renew_policy" @click="renewPolicy(expiredPolicy)">Renew Now!</div>&nbsp;&nbsp;&nbsp;
                      <router-link :to="{ name: 'PolicyView', params: { source: 'self', id: expiredPolicy.id } }" class="nex-Page-Link" :class="expiredPolicy.can_renew_policy ? 'in-renew-arrow' : ''">
                        <!-- <i class="fa fa-chevron-right"></i> -->
                        <!-- <img class="img-fluid in-w-10" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon"> -->
                        <span style="float:right" ><i class="arrow_risk right1 feedback_arrow"></i></span>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h2 style="color: rgba(0, 0, 0, 0.3) !important " v-if="expiredPolicies.length === 0">No Policy Available for Renewal</h2>
            </div>

          <!-- mobile view -->
          <div class="col-md-12 d-md-none">
            <div class="d-flex in-sm-listing ib-cursor-pointer" v-for="(expiredPolicy, index) in expiredPolicies" :key="'expiredPolicy' + index" @click="viewPolicy(expiredPolicy)">
              <div class="in-sm-firstdiv">
                <div class="in-listing-img in-sm-height">
                  <img class="img-fluid" :src="expiredPolicy.plan_image" v-if="expiredPolicy.plan_image != ''" />
                  <img class="img-fluid" :src="expiredPolicy.product_image" v-if="expiredPolicy.plan_image == ''" />
                  <div class="position-relative-box">
                  <img alt="icon" class="img-fluid small-icon" :src="expiredPolicy.company_logo_path" />
                  </div>
                </div>
              </div>
               <div class="in-sm-flex1">
                  <div class="d-flex in-sm-date">
                    <div>Order Date:&nbsp;</div>
                    <div>{{ formatDate(expiredPolicy.created_at) }}</div>
                  </div>
                  <div class="in-sm-title">{{ expiredPolicy.subclass_name }}
                    <small>{{ expiredPolicy.product_name }}</small>
                    <!-- <small class="ib-card-plan" v-if="expiredPolicy.plan_name != ''">{{ expiredPolicy.plan_name }}</small> -->
                  </div>
                <!-- <div class="in-sm-title" v-else>{{ document.subclass_name }}
                  <small class="ib-card-plan">{{ document.product_name }}</small>
                </div> -->
                <div>
                  <div class="d-flex" v-if="expiredPolicy.policy_no != null">
                    <div class="in-sm-property">Policy No.</div>
                    <div class="in-sm-value">{{ expiredPolicy.policy_no}}</div>
                  </div>
                  <div class="d-flex" v-else>
                    <div class="in-sm-property">Order No</div>
                    <div class="in-sm-value">{{ expiredPolicy.tcn_no}}</div>
                  </div>
                </div>
                <div>
                  <div class="d-flex">
                    <div class="in-sm-property">Expiry Date: </div>
                    <div class="in-sm-value">{{ formatDate(expiredPolicy.expires_at) }}</div>
                  </div>
                </div>
                <div class="">
                  <div class="d-flex">
                    <div class="in-sm-value ib-td-currency">PKR <span>{{ priceFormatter(expiredPolicy.paid_amount) }}</span></div>
                  </div>
                </div>
                <div class="ib-btn-primary" v-if="expiredPolicy.can_renew_policy" @click="renewPolicy(expiredPolicy)">Renew Now!</div>
                  <!-- <div class="in-sm-status ib-status" :class=" document.status +'-status'">{{ calculateExpiry(expiringPolicy.expires_at) }}</div> -->
              </div>
            </div>
            <h5 style="color: rgba(0, 0, 0, 0.3) !important " v-if="expiredPolicies.length === 0">No Policy Available for Renewal</h5>
          </div>
          <!-- mobile view -->

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import loading from '@/components/Loading/Loading';
  import moment from 'moment';

  export default {
    name: 'Renewals',
    components: {
      loading
    },
    data() {
      return {
        showLoader: false,
        expiringPolicies: [],
        expiredPolicies: []
      }
    },
    created: function () {
      const self = this;
      self.getPolicies();
    },
    methods: {
      priceFormatter(price) {
        return new Intl.NumberFormat('en-PK').format(price);
      },
      calculateExpiry(date) {
        var eventdate = moment(date, "YYYY-MM-DD");
        var todaysdate = moment();
        return eventdate.diff(todaysdate, 'days') < 0 ? 0 : eventdate.diff(todaysdate, 'days');
      },
      formatDate(date) {
        return moment(date, "YYYY-MM-DD").format('DD-MMM-YYYY');
      },
      async getPolicies() {
        const self = this;
        self.showLoader = true;
        await axios.get('customer/customer_policies_listing').then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            self.expiringPolicies = resp.data.data.policies.filter(x => x.consumer_status == 'expiring_soon');
            self.expiredPolicies = resp.data.data.policies.filter(x => x.consumer_status == 'expired' && x.can_renew_policy == 1);
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.response.data.errors != undefined) {
            error.response.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.response.data.message, { position: 'top-right' });
          }
          return false;
        });
      },
      renewPolicy(policy) {
        const self = this;
        if(policy.can_renew_policy) {
          self.$router.push({ name: 'Renew', params: { quotationId: policy.id, subClassId: policy.subclass_id, riskId: policy.risk_id, provideInformationThrough:policy.provide_information_through } });
        } else {
          $toast.error('Cannot renew this policy', { position: 'top-right' });
        }
      },
      viewPolicy(policy) {
        const self = this;
        // if(policy.can_renew_policy) {
        //   self.$router.push({ name: 'Renew', params: { quotationId: policy.id, subClassId: policy.subclass_id } });
        // } else {
        //   $toast.error('Cannot renew this policy', { position: 'top-right' });
        // }
        self.$router.push({ name: 'PolicyView', params: { source: 'self', id: policy.id } });
      },
      viewExpiringPolicy(policyId) {
        const self = this;
        self.$router.push({ name: 'PolicyView', params: { source: 'self', id: policyId } });
      }
    }
  }
</script>

<style scoped>
  .jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item {
    border: solid 1px transparent;
    color: #fff !important;
    height: 61px;
    border-radius: 31px;
    background-color: #def3f7;
    display: flex !important;
    align-items: center;
    justify-content: center;
  }
  .jbl-nav-tabs .nav-item .nav-link:hover, .jbl-nav-tabs .nav-item .nav-link:active, .jbl-nav-tabs .nav-item .nav-link:focus,.jbl-nav-tabs .nav-item .active {
    border: solid 1px var(--primary-color);
    background-color: var(--primary-color);
    color: #fff !important;
    height: 61px;
    border-radius: 31px;
    display: flex !important;
    align-items: center;
    justify-content: center;
  }
  .jbl-nav-tabs .nav-item .nav-link {
    color: #5b6770;
  }
  .jbl-nav-tabs {
    border-radius: 31px;
    box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
    background-color: #def3f7;
    border: 0;
    font-family: "Avenir Medium";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.29;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
    margin: 20px 0 10px 15px;
    /* padding-top: 1px;
    padding-bottom: 1px; */
  }
  .data-row p {
    color :#5b6770;
  }
  table > tbody > tr, .data-row {
    margin: 9px 0;
    padding: 10px;
    border-radius: 10px;
    border: solid 1px rgba(55, 141, 171, 0.25);
    background-color: #ffffff;
  }
  .data-row .action-area {
    text-align: right;
  }
  .data-row .action-area i {
    width: 7.9px;
    height: 14.6px;
    color: #5b6770;
  }
  .data-row .claim-row-sub-heading {
    color: #a9adaf;
  }
  .data-row .claim-row-sub-desc {
    color: #5b6770;
  }
  .data-row .status-danger {
    background-color: rgba(30, 203, 16, 0.09);
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    color: #1ecb10;
    letter-spacing: normal;
  }
  .data-row .status {
    margin: 10px 61.3px 10px 52px;
    padding: 6px 24px;
    border-radius: 6px;
    font-family: "Futura PT";
  }
  .data-row .claim-row-data {
    font-family: "Futura PT";
    font-size: 17px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 8px;
    letter-spacing: normal;
    text-align: left;
  }
  .data-row .claim-row-heading {
    font-family: "Futura PT";
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
  }
  .in-listing-img {
    width: 79px;
    height: 66px;
    background-color: #ecf3f5;
    border-radius: 11px;
    border: 1px solid gainsboro;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
   .in-listing-img img{
    width: 100% !important;
    max-width: 70px !important;
    max-height: 60px !important;
    height: auto !important;
  }

  .position-relative-box {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid gainsboro;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: absolute;
    bottom: -10px;
    right: -10px;
  }
   .position-relative-box img{
    width: 100% !important;
    max-width: 23px !important;
    height: auto !important;
  }
  /* table > tbody > tr > th > img,.data-img img {
    width: 79px;
    height: 66px;
    border-radius: 11px;
  }
  .position-relative .small-icon {
    border-radius: 50%;
    position: absolute;
    width: 25px;
    height: 25px;
    top: -20px;
    right: 0px;
  } */
  table.claim-listing {
    width: 100%;
    margin: 0 auto;
    font-family: Arial, sans-serif;
    border-collapse: separate;
    border-spacing: 0 10px;
  }
  table.claim-listing td {
    height: 84px !important;
    vertical-align: middle;
    text-align: center;
    position: relative;
  }
  @media (max-width:668px) {
    table.claim-listing td:not(:first-child) {
      height: 60px !important;
    }
    table.claim-listing tbody td:first-child {
      height: auto !important;
    }
  }
  table.claim-listing td:last-child:after {
    content: none;
  }
  table.claim-listing tbody td {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }
  @media (min-width:669px){
    table.claim-listing tbody td:first-child {
      border-left: 1px solid #eee;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    table.claim-listing tbody td:last-child {
      border-right: 1px solid #eee;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      /* text-align: right !important; */
    }
    table.claim-listing tbody tr {
      box-shadow: 0 0 0px 1px #d8eaf1;
    }
  }
  .jbl-table-heading {
    font-family: "Avenir Medium";
    font-weight: 500;
    text-align: left !important;
    font-size: 19px;
    color: #5b6770;
    text-transform: capitalize;
  }
  .jbl-table-heading span {
    font-size: 19px;
    font-size: 10px;
    color: #5b6770;
    font-weight: normal !important;
  }
  .jbl-date-td {
    font-family: "Avenir Medium";
    font-size: 19px;
    font-weight: 500;
    text-align: left;
    color: #5b6770;
  }
  .jbl-date-heading {
    color: #ef7c94 !important;
    font-family: "Avenir Book";
    font-size: 13px;
    text-align: left;
  }
  table.claim-listing .fa-chevron-right {
    padding-right: 2rem;
    color: #5b6770;
  }
  .jbl-flex-td {
    display: flex;
    flex-direction: column;
  }
  @media (min-width:668px) and (max-width:992px) {
    .jbl-table-heading {
      font-size: 14px;
    }
    .jbl-date-td{
      font-family:"Futura PT Medium";
      font-size: 12px;
    }
    table.claim-listing .fa-chevron-right {
      padding-right: 1rem;
      color: #5b6770;
    }
  }
  .d2c-main-classes .d2c-class-btn::after {
    content: '';
    width: 0;
    height: 35px;
    border: solid 1px #049ab3;
    position: relative;
    right: -16px;
  }
  .d2c-main-classes.d2c-class-tabs button.d2c-class-btn::after {
    content: '';
    border: none !important;
  }
  .d2c-main-classes button:last-child.d2c-class-btn::after {
    content: '';
    border: none !important;
  }
  .nex-Page-Link .fa-chevron-right {
    color: #aeccd6 !important;
    font-weight: normal !important;
  }
  .expired-title {
    font-family: "Avenir Medium";
    font-size: 19px;
    font-weight: 500;
    text-align: left;
    color: #5b6770;
    position: relative;
    bottom: 10px;
  }
  .expired-title small {
    font-size: 10px;
    color: #ef7c94;
  }
  .expired-days {
    font-family: "Avenir Heavy";
    font-size: 43px;
    /* font-weight: 900; */
    letter-spacing: -1.46px;
    text-align: left;
    color: #ef7c94;
  }
  .expired-days small {
     font-family: "Avenir Book";
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: #939393;
    position: relative;
    right: 6px;
  }
  .expired-days-label {
    font-family: "Avenir Heavy" !important;
    font-size: 10px !important;
    /* font-weight: 900 !important; */
    text-align: left !important;
    color: #3d9cbd !important;
    position: relative;
    top: 10px;
  }
  .img-div{
    border: 1px solid gainsboro !important;
    border-radius: 11px !important;
    width: 100px !important;
  }
  .in-flex-data{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .in-renew-flex{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .in-renew-arrow i.fa-chevron-right{
    padding-right: 23px !important;
  }
  .ib-btn-primary{
    padding: .5rem .8rem !important;
  }
@media (max-width:550px){
  .jbl-nav-tabs {
    font-size: 14px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Renewals/Index.vue